module.exports = __webpack_public_path__ + "img/account_center_banner.7a69912a.png";